module.exports = __webpack_public_path__ + "img/2-4.1c141c82.png";